import { Link } from "@tanstack/react-router";
import { Shield, Lock, Eye, Award } from "lucide-react";

const trust = [
  {
    icon: Shield,
    label: "Secure Data Handling",
    detail: "Your information is protected using industry-standard security practices.",
  },
  {
    icon: Lock,
    label: "256-Bit Encryption",
    detail: "Your information is encrypted during secure transmission.",
  },
  {
    icon: Eye,
    label: "Your Data Is Never Sold",
    detail: "We do not sell your personal information.",
  },
  {
    icon: Award,
    label: "Private Account Access",
    detail: "Your invoices and reports are restricted to authorized account access.",
  },
];

const legalLinks = [
  { to: "/terms", label: "Terms" },
  { to: "/privacy", label: "Privacy" },
  { to: "/ai-disclaimer", label: "AI Disclaimer" },
  { to: "/refund-policy", label: "Refunds" },
  { to: "/data-retention", label: "Data Retention" },
  { to: "/support", label: "Support" },
] as const;

export function SiteFooter() {
  return (
    <footer className="mt-24 bg-navy text-navy-foreground">
      <div className="container-page py-14">
        <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-4">
          {trust.map((t) => (
            <div key={t.label} className="flex items-start gap-3">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-white/10 ring-1 ring-inset ring-white/10">
                <t.icon className="h-5 w-5" />
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold">{t.label}</div>
                <div className="text-xs text-white/70">{t.detail}</div>

              </div>
            </div>
          ))}
        </div>
        <div className="mt-10 flex flex-col items-start justify-between gap-6 border-t border-white/10 pt-6 md:flex-row md:items-center">
          <div className="flex items-start gap-2.5">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/10 ring-1 ring-inset ring-white/10">
              <Shield className="h-5 w-5" />
            </div>
            <div className="min-w-0 leading-tight">
              <div className="text-sm font-semibold tracking-wide">INVOICE INTELLIGENCE AI</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-white/60">
                AI Invoice Reviews &amp; Full-Service Negotiation
              </div>
              <div className="mt-2 text-xs text-white/60">
                © {new Date().getFullYear()} ClaimGuard. All rights reserved.
              </div>
            </div>
          </div>
          <nav className="flex flex-wrap gap-1 text-xs text-white/70">
            {legalLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="rounded-md px-2 py-1 text-white/70 transition hover:bg-white/10 hover:text-white"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
